import React from 'react';
import cx from 'classnames';
import { SLDSCombobox } from '@salesforce/design-system-react';

function Combobox({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSCombobox, Object.assign({}, props, {
    className: cx(className, "tds-combobox")
  }));
}
Combobox.displayName = "Combobox";

export { Combobox as default };
